import script from "./MultiplePictureChoiceType.vue?vue&type=script&lang=js"
export * from "./MultiplePictureChoiceType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__